import { useMemo } from 'react';

import { ROUTE_QUERY_PARAM } from '../../app/Routes/const';
import { Tabs, Tab } from '../../components';
import { Connect } from './google-connect/Connect';
import { OutboundCall } from './outbound-call/OutboundCall';
import { usePermissionAllowed } from '../../hooks';
import {
  filterTabsByAllowedActions,
  type PermissionScopedTab,
  useTabPersistence,
} from '../../shared';
import { PERMISSIONS } from '../../shared/constants/permissions';

type TabsEnum = 'outbound-call' | 'google-connect';
const CALL_MANAGEMENT_TABS: (PermissionScopedTab<TabsEnum> & {
  label: string;
})[] = [
  {
    name: 'outbound-call',
    label: 'Outbound Call',
    action: PERMISSIONS.MAKE_CALL,
  },
  {
    name: 'google-connect',
    label: 'Conference Call',
    action: PERMISSIONS.MAKE_CONFERENCE_CALL,
  },
];

const CallManagementPage = () => {
  const hasMakeCall = usePermissionAllowed([PERMISSIONS.MAKE_CALL]);
  const hasMakeConferenceCall = usePermissionAllowed([
    PERMISSIONS.MAKE_CONFERENCE_CALL,
  ]);

  const availableTabs = useMemo<TabsEnum[]>(() => {
    const allowedActions: SpPermission[] = [];
    if (hasMakeCall) allowedActions.push(PERMISSIONS.MAKE_CALL);
    if (hasMakeConferenceCall) {
      allowedActions.push(PERMISSIONS.MAKE_CONFERENCE_CALL);
    }

    return filterTabsByAllowedActions(CALL_MANAGEMENT_TABS, allowedActions);
  }, [hasMakeCall, hasMakeConferenceCall]);

  const { selectedTab, setSelectedTab, isReady } = useTabPersistence(
    {
      paramName: ROUTE_QUERY_PARAM.TAB,
      defaultTab: availableTabs[0] as TabsEnum | undefined,
      updateHistory: true,
    },
    availableTabs
  );

  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Tabs<TabsEnum>
        tabs={CALL_MANAGEMENT_TABS}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="outbound-call">
          <OutboundCall />
        </Tab>
        <Tab name="google-connect">
          <Connect />
        </Tab>
      </Tabs>
    </>
  );
};

export default CallManagementPage;
